
import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SITE } from '@/data/site';
import { trackPhoneClick } from '@/lib/analytics';

function CallButton({ variant = 'default', className = '', showIcon = true, children }) {
  return (
    <Button
      variant={variant}
      className={className}
      asChild
    >
      <a
        href={`tel:${SITE.phoneE164Primary}`}
        onClick={() => trackPhoneClick(SITE.phoneE164Primary)}
      >
        {showIcon && <Phone className="w-4 h-4 mr-2" />}
        {children || SITE.phonePrimary}
      </a>
    </Button>
  );
}

export default CallButton;
